<template>
  <div class="prize-card">
    <pageTitle :pageTitle="lotteryId ? $t('lang.k_228001') : $t('lang.k_228002')"></pageTitle>
    <div class="card__body">
      <vh-tabs v-model="activeName" @tab-click="handleChangeTab">
        <vh-tab-pane :label="$t('lang.k_228003')" name="first">
          <div class="give-item">
            <div class="give-prize">
              <vh-form
                :model="formData"
                ref="ruleForm"
                :label-width="$i18n.locale == 'en' ? '90px' : '80px'"
              >
                <vh-form-item :label="$t('lang.k_228004')" required>
                  <div class="prize-type">
                    <div
                      class="przieImg prizeNoBorder"
                      :class="isChecked == 0 ? 'checkedBorder' : ''"
                    >
                      <upload
                        class="giftUpload"
                        v-model="previewSrc"
                        :domain_url="previewSrc"
                        :on-success="prizeLoadSuccess"
                        @delete="deleteImg"
                        @fullCover="changeType(0)"
                        :widthImg="86"
                        :heightImg="88"
                        :isFullCover="false"
                        :before-upload="beforeUploadHandler"
                      ></upload>
                      <label class="img-tangle" v-show="isChecked == 0">
                        <img src="../../../common/images/icon-choose.png" alt="" />
                      </label>
                    </div>
                    <p
                      :class="isChecked == 1 ? 'active' : ''"
                      class="przieImg"
                      @click="changeType(1)"
                    >
                      <img src="../../../common/images/gif/prize01.png" alt="" />
                      <label class="img-tangle" v-show="isChecked == 1">
                        <img src="../../../common/images/icon-choose.png" alt="" />
                      </label>
                    </p>
                    <p
                      :class="isChecked == 2 ? 'active' : ''"
                      class="przieImg"
                      @click="changeType(2)"
                    >
                      <img src="../../../common/images/gif/prize02.png" alt="" />
                      <label class="img-tangle" v-show="isChecked == 2">
                        <img src="../../../common/images/icon-choose.png" alt="" />
                      </label>
                    </p>
                    <p
                      :class="isChecked == 3 ? 'active' : ''"
                      class="przieImg"
                      @click="changeType(3)"
                    >
                      <img src="../../../common/images/gif/prize03.png" alt="" />
                      <label class="img-tangle" v-show="isChecked == 3">
                        <img src="../../../common/images/icon-choose.png" alt="" />
                      </label>
                    </p>
                  </div>
                  <p style="color: #999">{{ $t('lang.k_228005') }}</p>
                </vh-form-item>
                <vh-form-item :label="$t('lang.k_228006')" required>
                  <VhallInput
                    v-model="formData.title"
                    autocomplete="off"
                    v-clearEmoij
                    :maxlength="100"
                    :placeholder="$t('lang.k_228007')"
                    show-word-limit
                  ></VhallInput>
                </vh-form-item>
                <vh-form-item :label="$t('lang.k_228008')" required>
                  <VhallInput
                    v-model="formData.description"
                    autocomplete="off"
                    v-clearEmoij
                    :maxlength="20"
                    :placeholder="$t('lang.k_228009')"
                    show-word-limit
                  ></VhallInput>
                </vh-form-item>
                <vh-form-item :label="$t('lang.k_228010')">
                  <vh-radio-group v-model="formData.lottery_method" class="lottery_method">
                    <vh-radio :label="0">{{ $t('lang.k_228011') }}</vh-radio>
                    <vh-radio :label="1">
                      {{ $t('lang.k_228012') }}
                      <vh-input
                        v-model="formData.lottery_countdown"
                        maxlength="4"
                        placeholder="1-9999"
                        @input="inputCount"
                      >
                        <template slot="append">{{ $t('lang.k_228013') }}</template>
                      </vh-input>
                      {{ $t('lang.k_228014') }}
                    </vh-radio>
                  </vh-radio-group>
                </vh-form-item>
                <vh-form-item :label="$t('lang.k_228015')">
                  <p class="alertTxt">{{ $t('lang.k_228016') }}</p>
                  <vh-radio-group v-model="formData.display_of_results" class="position">
                    <vh-radio :label="0">{{ $t('lang.k_228017') }}</vh-radio>
                    <vh-radio :label="1">{{ $t('lang.k_228018') }}</vh-radio>
                  </vh-radio-group>
                </vh-form-item>
                <vh-form-item>
                  <!-- <vh-button @click="backToList" plain round size="medium" v-preventReClick>
                  返回列表
                </vh-button> -->
                  <vh-button
                    round
                    type="primary"
                    size="medium"
                    :disabled="Boolean(!formData.title)"
                    @click="lotterySave"
                    v-preventReClick
                  >
                    {{ $t('lang.k_228019') }}
                  </vh-button>
                </vh-form-item>
              </vh-form>
            </div>
            <div class="give-show">
              <div class="give-people">
                <div
                  class="prize-mask"
                  :class="formData.display_of_results == 1 ? 'partScreen' : ''"
                >
                  <div class="prize-show" :style="`backgroundImage: url(${backgroundImg})`">
                    <div :class="`prize-title prize-title_0${isChecked}`">
                      {{ formData.description }}
                    </div>
                  </div>
                </div>
                <!-- <div class="sureBtn">{{ formData.description || '正在进行抽奖' }}</div> -->
              </div>
            </div>
          </div>
        </vh-tab-pane>
        <vh-tab-pane :label="$t('lang.k_228020')" name="four" :disabled="!lotteryId">
          <div class="give-item">
            <div class="give-prize-user give-live give-condition">
              <vh-form :model="conditionForm" label-width="140px">
                <vh-form-item :label="$t('lang.k_228021')" class="give-condition_option">
                  <vh-radio-group v-model="conditionForm.lottery_type" style="width: 550px">
                    <vh-radio :label="1">{{ $t('lang.k_228022') }}</vh-radio>
                    <vh-radio :label="3" :disabled="configInfo['ui.hide_sign_in'] == 0">
                      {{ $t('lang.k_228023') }}
                      <span class="color_red" v-if="configInfo['ui.hide_sign_in'] == 0">
                        {{ $t('lang.k_228024') }}
                      </span>
                    </vh-radio>
                    <vh-radio :label="2" :disabled="configInfo['ui.hide_survey'] == 0">
                      {{ $t('lang.k_228025') }}
                      <span
                        class="set-btn"
                        @click="settingCondition(2)"
                        v-if="configInfo['ui.hide_survey'] == 1"
                      >
                        {{ $t('lang.k_228026') }}
                      </span>
                      <span class="color_red" v-else>{{ $t('lang.k_228024') }}</span>
                    </vh-radio>
                    <vh-radio :label="8" class="set-code">{{ $t('lang.k_228027') }}</vh-radio>
                    <vh-radio :label="21" :disabled="configInfo['exam'] == 0">
                      {{ $t('lang.k_228028') }}
                      <span
                        class="set-btn"
                        @click="settingCondition(21)"
                        v-if="configInfo['exam'] == 1"
                      >
                        {{ $t('lang.k_228026') }}
                      </span>
                      <span class="color_red" v-else>{{ $t('lang.k_228024') }}</span>
                    </vh-radio>
                  </vh-radio-group>
                  <VhallInput
                    v-model="conditionForm.lottery_code"
                    style="width: 400px; display: block"
                    v-if="conditionForm.lottery_type == 8"
                    autocomplete="off"
                    v-clearEmoij
                    :maxlength="15"
                    :placeholder="$t('lang.k_228029')"
                    show-word-limit
                  ></VhallInput>
                </vh-form-item>
                <vh-form-item
                  :label="$t('lang.k_228030')"
                  v-if="[2, 3, 21].includes(conditionForm.lottery_type)"
                >
                  <vh-radio v-model="conditionForm.lottery_tips" :label="0">
                    {{ $t('lang.k_228031') }}
                  </vh-radio>
                  <br />
                  <vh-radio v-model="conditionForm.lottery_tips" :label="1">
                    {{ $t('lang.k_228032') }}
                    <span class="set-btn">
                      {{ $t('lang.k_228033') }}
                      <span class="example-preview">
                        <img src="./images/lottery_preview.png" alt="" />
                      </span>
                    </span>
                  </vh-radio>
                </vh-form-item>
                <vh-form-item :label="$t('lang.k_228034')" class="give-condition_user">
                  <p class="set_user">
                    {{ $t('lang.k_228035') }}
                    <template>
                      <span class="set_audience" @click="settingAudience">
                        {{ $t('lang.k_228026') }}
                      </span>
                      <span
                        v-if="!isEmbed && configInfo['white_list'] == 1"
                        class="set_audience set_left"
                        @click="showImportUser"
                      >
                        {{ $t('lang.k_228036') }}
                      </span>
                    </template>
                    <!-- <template v-else>
                    <span class="color_red">{{ $t('lang.k_228024') }}</span>
                  </template> -->
                  </p>
                  <!-- <template v-if="configInfo['white_list'] && configInfo['white_list'] == 1"> -->
                  <div class="winner_pool" v-if="lotteryWinList.length">
                    <p class="set_user">{{ $t('lang.k_228037') }}</p>
                    <div class="set_list">
                      <div
                        class="set_list_item"
                        v-for="(item, index) in lotteryWinList"
                        :key="index"
                      >
                        <p>{{ item.subject }}</p>
                        <span v-show="item.type == 'group'">
                          ({{ item.num }}{{ $t('lang.k_228038') }})
                        </span>
                        <span @click="deleteWinList(item)">
                          <i class="vh-icon-close"></i>
                        </span>
                      </div>
                    </div>
                  </div>

                  <div class="winner_pool" v-if="lotteryBlackList.length">
                    <p class="set_user">{{ $t('lang.k_228039') }}</p>
                    <div class="set_list">
                      <div class="set_list_item" v-for="item in lotteryBlackList" :key="item.key">
                        <p>{{ item.subject }}</p>
                        <span v-show="item.type == 'group'">
                          ({{ item.num }}{{ $t('lang.k_228038') }})
                        </span>
                        <span @click="deleteBlackList(item)">
                          <i class="vh-icon-close"></i>
                        </span>
                      </div>
                    </div>
                  </div>
                  <!-- </template> -->
                </vh-form-item>
                <vh-form-item :label="$t('lang.k_228040')">
                  <vh-checkbox v-model="conditionForm.lottery_repeat">
                    {{ $t('lang.k_228041') }}
                  </vh-checkbox>
                  <br />
                  <vh-checkbox v-model="conditionForm.can_remaining_lottery">
                    {{ $t('lang.k_228042') }}
                  </vh-checkbox>
                  <br />
                  <vh-checkbox v-model="conditionForm.lottery_look">
                    {{ $t('lang.k_228043') }}
                  </vh-checkbox>
                  <br />
                  <vh-checkbox v-model="conditionForm.can_block_overseas">
                    {{ $t('lang.k_228044') }}
                  </vh-checkbox>
                </vh-form-item>
              </vh-form>
            </div>
          </div>
          <div class="condition_btn">
            <!-- <vh-button
            size="medium"
            type="info"
            plain
            round
            class="transparent-btn"
            v-preventReClick
            @click="backToList"
          >
            返回列表
          </vh-button>
          <vh-button size="medium" @click="backPreLottery('first')" type="info" plain round>
            上一步
          </vh-button> -->
            <vh-button
              size="medium"
              type="primary"
              round
              @click="sureConditionInfo"
              v-preventReClick
            >
              {{ $t('lang.k_228019') }}
            </vh-button>
          </div>
        </vh-tab-pane>
        <vh-tab-pane :label="$t('lang.k_228045')" name="second" :disabled="!lotteryId">
          <div class="give-item">
            <div class="give-prize give-live">
              <vh-form :model="givePrizeForm" label-width="80px">
                <vh-form-item :label="$t('lang.k_228046')">
                  <vh-radio-group v-model="radioType">
                    <vh-radio label="1">{{ $t('lang.k_228047') }}</vh-radio>
                    <vh-radio label="2">{{ $t('lang.k_228048') }}</vh-radio>
                    <vh-radio label="3">{{ $t('lang.k_228049') }}</vh-radio>
                    <vh-radio label="4">{{ $t('lang.k_228050') }}</vh-radio>
                  </vh-radio-group>
                </vh-form-item>
                <div v-if="radioType === '1'">
                  <div class="prize-con">
                    <div class="prize-js">
                      <vh-form-item
                        v-for="(item, index) in givePrizeList"
                        :key="index"
                        :label="item.field"
                        :ref="`${item.field_key}`"
                      >
                        <VhallInput
                          v-model="givePrizeForm[item.field_key]"
                          type="text"
                          show-word-limit
                          :maxlength="awardLimitNum[item.rank > 3 ? 3 : item.rank - 1]"
                          :placeholder="item.placeholder"
                        ></VhallInput>
                        <div class="isDelete" v-if="index > 0">
                          <i
                            class="iconfont-v3 saasicon-trash"
                            @click="deleteGivePrize(index)"
                            v-if="!Boolean(item.is_system)"
                          ></i>
                          <p class="switch__box">
                            <template v-if="item.field_key === 'phone'">
                              <vh-switch
                                v-model="item.is_check"
                                :inactive-text="$t('lang.k_228051')"
                                :active-value="1"
                                :inactive-value="0"
                                @change="handlePhoneCheckChange"
                                style="margin-right: 15px"
                              ></vh-switch>
                            </template>
                            <vh-switch
                              v-model="item.is_required"
                              :inactive-text="$t('lang.k_228052')"
                            ></vh-switch>
                          </p>
                        </div>
                      </vh-form-item>
                      <div class="add-prize" @click="addField" v-if="givePrizeList.length < 6">
                        <i class="vh-icon-plus"></i>
                        {{ $t('lang.k_228053') }}
                      </div>
                      <vh-form-item :label="$t('lang.k_228054')">
                        <vh-switch
                          v-model="compulsory_award"
                          :active-value="1"
                          :inactive-value="0"
                          :active-text="$t('lang.k_228055')"
                        ></vh-switch>
                      </vh-form-item>
                      <vh-form-item :label="$t('lang.k_228056')">
                        <ComplianceChoice
                          ref="complianceChoice"
                          v-model="privacyStatementData"
                          @change="complianceChange"
                        ></ComplianceChoice>
                      </vh-form-item>
                    </div>
                  </div>
                </div>
                <div v-if="radioType === '2'">
                  <div class="prize-con">
                    <div class="give-prize">
                      <vh-form :model="formData" ref="ruleForm" label-width="80px">
                        <vh-form-item :label="$t('lang.k_228057')">
                          <vh-input
                            v-model="privatePrizeForm.private_number"
                            autocomplete="off"
                            v-clearEmoij
                            :placeholder="$t('lang.k_228058')"
                          ></vh-input>
                        </vh-form-item>
                        <vh-form-item :label="$t('lang.k_228059')">
                          <upload
                            class="giftUpload"
                            v-model="privatePrizeForm.private_qrcode"
                            :domain_url="privatePrizeForm.private_qrcode"
                            :on-success="privatePrizeLoadSuccess"
                            @delete="deletePrivateImg"
                            :before-upload="beforeUploadHandler"
                          >
                            <div slot="tip">
                              <p>{{ $t('lang.k_228060') }}</p>
                              <p>{{ $t('lang.k_228061') }}</p>
                            </div>
                          </upload>
                        </vh-form-item>
                        <vh-form-item :label="$t('lang.k_228062')">
                          <vh-input
                            v-model="privatePrizeForm.tip_note"
                            autocomplete="off"
                            v-clearEmoij
                            :maxlength="20"
                            :placeholder="$t('lang.k_228063')"
                            show-word-limit
                          ></vh-input>
                        </vh-form-item>
                        <!-- <vh-form-item>
                        <vh-button type="primary"
                          round
                          @click="lotterySave"
                          v-preventReClick>返回列表</vh-button>
                        <vh-button type="primary"
                          round
                          @click="lotterySave"
                          v-preventReClick>保存并下一步</vh-button>
                      </vh-form-item> -->
                      </vh-form>
                    </div>
                  </div>
                </div>
                <div v-if="radioType === '3'" class="award-no">
                  <div class="award-no-wrapper">
                    <span><img src="./images/no-null.png" alt="" /></span>
                    <p class="award_no_tip">{{ $t('lang.k_228064') }}</p>
                  </div>
                </div>
                <div v-if="radioType === '4'" class="award-custom">
                  <vh-form
                    :model="customPrizeForm"
                    ref="customPrizeForm"
                    :rules="customPrizeFormRules"
                    label-width="80px"
                  >
                    <vh-form-item :label="$t('lang.k_228065')">
                      <vh-input
                        :placeholder="$t('lang.k_228066')"
                        :maxlength="15"
                        show-word-limit
                        v-model="customPrizeForm.custom_btn_txt"
                      ></vh-input>
                    </vh-form-item>
                    <vh-form-item :label="$t('lang.k_228067')" prop="custom_link">
                      <vh-input
                        :placeholder="$t('lang.k_228068')"
                        v-model="customPrizeForm.custom_link"
                      ></vh-input>
                    </vh-form-item>
                    <vh-form-item>
                      <p class="notice_txt">
                        {{ $t('lang.k_228069') }}
                        <br />
                        {{ $t('lang.k_228070') }}
                        <br />
                        {{ $t('lang.k_228071') }}
                      </p>
                    </vh-form-item>
                  </vh-form>
                </div>
              </vh-form>
              <div class="award-save">
                <!-- <vh-button
                    size="medium"
                    type="info"
                    plain
                    round
                    class="transparent-btn"
                    v-preventReClick
                    @click="backToList"
                  >
                    返回列表
                  </vh-button>
                  <vh-button size="medium" @click="backPreLottery('four')" type="info" plain round>
                    上一步
                  </vh-button> -->
                <vh-button
                  type="primary"
                  size="medium"
                  round
                  @click="sureGivePrize"
                  :disabled="
                    radioType === '2' &&
                    !(privatePrizeForm.private_qrcode || privatePrizeForm.private_number)
                  "
                  v-preventReClick
                >
                  {{ $t('lang.k_228019') }}
                </vh-button>
              </div>
            </div>
            <!-- 预览 -->
            <div class="give-show">
              <div class="give-people">
                <div class="prize-mask">
                  <!-- 寄送奖品 -->
                  <div
                    v-if="radioType == 1"
                    class="accept-review way1"
                    :class="compulsory_award == 1 ? 'compulsoryAward' : ''"
                  >
                    <div v-if="!compulsory_award" class="has-close"></div>
                    <div class="padding-container">
                      <div class="give-msg">
                        <vh-form :model="givePrizeForm">
                          <vh-form-item
                            v-for="(item, index) in givePrizeList"
                            :key="index"
                            class="form-item"
                          >
                            <span class="red" v-if="item.is_required == 1">*</span>
                            <vh-input
                              v-model="givePrizeForm[item.field_key]"
                              readonly
                              type="text"
                              :placeholder="item.placeholder"
                            ></vh-input>
                          </vh-form-item>
                        </vh-form>
                      </div>
                    </div>
                    <div class="sureBtn">{{ $t('lang.k_228072') }}</div>
                    <span class="privacy-preview" v-html="privacyHtm"></span>
                  </div>

                  <!-- 私信兑奖 -->
                  <div class="accept-review way2" v-else-if="radioType == 2">
                    <div class="padding-container">
                      <div class="reward-container_service">
                        <div>
                          <p class="service-title" v-if="privatePrizeForm.private_number">
                            {{ privatePrizeForm.private_number }}
                          </p>
                          <div class="reward-service" v-if="privatePrizeForm.private_qrcode">
                            <img :src="privatePrizeForm.private_qrcode" alt="" />
                          </div>
                          <p class="service-title" v-if="privatePrizeForm.tip_note">
                            {{ privatePrizeForm.tip_note }}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 无需领奖 -->
                  <div class="give-show_no" v-else-if="radioType == 3">
                    <img src="./images/no-award.png" alt="" />
                  </div>
                  <!--自定义领奖-->
                  <div class="custom_receive" v-else-if="radioType == 4">
                    <img src="./images/custom_preview.png" />
                    <a :href="customPrizeForm.custom_link" target="_blank">
                      {{ customPrizeForm.custom_btn_txt }}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </vh-tab-pane>
        <vh-tab-pane name="third" :disabled="!lotteryId">
          <span slot="label">
            {{ $t('lang.k_228073') }}
            <vh-tooltip
              class="prize--set"
              effect="dark"
              placement="right"
              v-tooltipMove
              style="margin-left: 5px"
            >
              <i class="iconfont-v3 saasicon_help_m"></i>
              <div slot="content">
                {{ $t('lang.k_228074') }}
                <br />
                {{ $t('lang.k_228075') }}
                <br />
                {{ $t('lang.k_228076') }}
              </div>
            </vh-tooltip>
          </span>
          <div class="prize-info">
            <prize-list
              ref="prizeTable"
              @backToList="backToList"
              @backPreLottery="backPreLottery"
              :source="'0'"
              :lotteryId="lotteryId"
              :roomId="roomId"
            ></prize-list>
          </div>
        </vh-tab-pane>
      </vh-tabs>
    </div>
    <setting-question ref="settingQuestion" @selectQuestion="selectQuestion"></setting-question>
    <setting-exam ref="settingExamDom" @selectExam="selectExam"></setting-exam>
    <setting-audience ref="settingAudience" @selectAudience="selectAudience"></setting-audience>
    <begin-play :webinarId="$route.params.str"></begin-play>
  </div>
</template>

<script>
  import to from 'await-to-js';
  import PageTitle from '@/components/PageTitle';
  import upload from '@/components/Upload/main';
  import prizeList from '../../MaterialModule/prize';
  import beginPlay from '@/components/beginBtn';
  import prize0 from '@/common/images/gif/prize01.gif';
  import prize1 from '@/common/images/gif/prize02.gif';
  import prize2 from '@/common/images/gif/prize3.gif';
  import { sessionOrLocal, isEmbed, embedRoomId } from '@/utils/utils';
  import settingQuestion from './components/setting-question.vue';
  import settingExam from './components/setting-exam.vue';
  import settingAudience from './components/setting-audience.vue';
  import ComplianceChoice from '@/components/privacy-compliance/ComplianceChoice.vue';

  export default {
    name: 'prizeSet',
    data() {
      return {
        isEmbed: isEmbed(),
        prizeInfoStatus: false,
        backgroundImg: '',
        activeName: 'first',
        configInfo: JSON.parse(sessionOrLocal.get('WEBINAR_PES', 'localStorage')),
        formData: {
          title: '',
          description: this.$t('lang.k_228077'),
          reDescription: '',
          reTitle: '',
          lottery_method: 0,
          lottery_countdown: '',
          display_of_results: 0
        },
        previewSrc: null,
        givePrizeForm: {
          adressCheced: false,
          name: '',
          phone: '',
          address: '',
          user_define_100: '',
          user_define_101: '',
          user_define_102: '',
          placeholder: ''
        },
        compulsory_award: 0,
        privatePrizeForm: {
          tip_note: this.$t('lang.k_228063'),
          private_qrcode: '',
          private_number: ''
        },
        action: `${process.env.VUE_APP_BASE_URL}/v3/vss/lottery/save-prize-image`,
        total: 100,
        length: 0,
        isChecked: 1,
        localImg: 0,
        prizeUrl: [prize0, prize1, prize2],
        prizeInfo: {}, // 获得奖品的信息
        awardLimitNum: [20, 20, 50, 100],
        givePrizeList: [
          {
            is_system: 1,
            field: this.$t('lang.k_228078'),
            field_key: 'name',
            is_required: true,
            placeholder: this.$t('lang.k_228079'),
            rank: 1
          },
          {
            is_system: 1,
            field: this.$t('lang.k_228080'),
            field_key: 'phone',
            is_required: true,
            is_check: 1, // 1：按照11位手机号检测  0：按照20位数字检测
            placeholder: this.$t('lang.k_228081'),
            rank: 2
          },
          {
            is_system: 1,
            field: this.$t('lang.k_228082'),
            field_key: 'address',
            is_required: false,
            placeholder: this.$t('lang.k_228083'),
            rank: 3
          }
        ],
        privatePrizeList: [
          {
            is_system: 1,
            field: this.$t('lang.k_228057'),
            field_key: 'private_number',
            is_required: false,
            placeholder: '',
            rank: 1
          },
          {
            is_system: 1,
            field: this.$t('lang.k_228059'),
            field_key: 'private_qrcode',
            is_required: false,
            placeholder: '',
            rank: 2
          },
          {
            is_system: 1,
            field: this.$t('lang.k_228062'),
            field_key: 'tip_note',
            is_required: true,
            placeholder: this.$t('lang.k_228084'),
            rank: 3
          }
        ],
        prizeForm: {
          name: '',
          imageUrl: ''
        },
        // 条件与中奖用户设置信息
        conditionForm: {
          lottery_type: 1,
          lottery_tips: 0,
          lottery_code: '',
          lottery_repeat: false,
          can_remaining_lottery: false,
          lottery_look: false,
          can_block_overseas: false
        },
        lotteryWinList: [],
        lotteryBlackList: [],
        lottery_question: {
          type: 1,
          survey_list: []
        },
        lottery_qa: {
          type: 1,
          score: '',
          fqa_list: []
        },
        index: 0,
        isError: false,
        rules: {
          name: [{ required: true, message: this.$t('lang.k_228085'), trigger: 'blur' }]
        },
        customPrizeForm: {
          custom_btn_txt: this.$t('lang.k_228066'),
          custom_link: ''
        },
        customPrizeFormRules: {
          custom_link: [
            { required: true, message: this.$t('lang.k_228086'), trigger: 'blur' },
            {
              pattern: /(https):\/\/[\w\-_]+(\.[\w\-_]+).*?/,
              message: this.$t('lang.k_228087'),
              trigger: 'blur'
            }
          ]
        },
        isLive: false,
        localLottery: {
          // 抽奖页信息
          description: '',
          title: ''
        },
        lotteryPageMessage: {
          // 领奖页信息
        },
        radioType: '1',
        partRadio: '1',
        lotteryId: '', // 当前的抽奖的id
        roomId: embedRoomId() || this.$route.query.roomId,
        // 隐私协议相关数据
        privacyStatementData: {
          statement_status: 0, //默认用系统自带协议
          statement_content: '',
          statement_info: []
        },
        privacyHtm: ''
      };
    },
    components: {
      PageTitle,
      upload,
      beginPlay,
      // createPrize,
      prizeList,
      settingQuestion,
      settingExam,
      settingAudience,
      ComplianceChoice
    },
    watch: {
      activeName() {
        if (this.activeName == 'first') {
          this.lotteryGet();
        } else if (this.activeName == 'second') {
          this.getGivePrize();
        } else if (this.activeName == 'third') {
          this.$refs.prizeTable.getTableList();
        } else if (this.activeName == 'four') {
          this.getConditionInfo();
        }
      }
    },
    created() {
      if (this.$route.query.lotteryId) {
        this.lotteryId = this.$route.query.lotteryId;
      }
      this.userId = JSON.parse(sessionOrLocal.get('userId'));
      this.backgroundImg = this.prizeUrl[0];
      console.log(this.configInfo, '??权限');
      // 问卷：perssionInfo['ui.hide_survey'] == 1
      // 快问快答：perssionInfo['exam'] == 1
      // 签到：['ui.hide_sign_in'] == 1
      // 观众：white_list
    },
    async mounted() {
      this.activeName = this.$route.query.index || 'first';
      await this.getActice();
      this.lotteryGet();
    },
    methods: {
      backToList() {
        this.$router.push({
          path: `${isEmbed() ? '/embed' : ''}/live/prizeList/${this.$route.params.str}`,
          query: {
            roomId: embedRoomId() || this.$route.query.roomId
          }
        });
      },
      // 返回上一步
      backPreLottery(name) {
        this.handleChangeTab({ name });
      },
      settingCondition(index) {
        if (index == 2) {
          this.$refs.settingQuestion.openSettingDialog(this.lotteryId, this.lottery_question);
        } else {
          this.$refs.settingExamDom &&
            this.$refs.settingExamDom.open(this.lotteryId, this.lottery_qa);
        }
      },
      getActice() {
        return new Promise((resolve, reject) => {
          this.$fetch('getWebinarInfo', { webinar_id: this.$route.params.str }).then(res => {
            if (res.code == 200) {
              if (res.data.webinar_state == 1) {
                this.isLive = true;
              }
            } else {
              this.$vhMessage.warning(res.msg);
            }
            resolve();
          });
        });
      },
      // 条件与中奖用户设置 获取信息
      getConditionInfo() {
        let params = {
          webinar_id: this.$route.params.str,
          lottery_id: this.lotteryId
        };
        this.$fetch('getConditionInfo', params).then(res => {
          if (res.code === 200 && res.data) {
            this.conditionForm.lottery_type = res.data.lottery_type;
            this.conditionForm.lottery_look = Boolean(res.data.can_look_winner_list);
            this.conditionForm.can_block_overseas = Boolean(res.data.can_block_overseas);
            this.conditionForm.lottery_repeat = Boolean(res.data.can_repeat_lottery);
            this.conditionForm.can_remaining_lottery = Boolean(res.data.can_remaining_lottery);
            this.conditionForm.lottery_tips = res.data.show_discontent_tips;
            const user_setting = res.data.user_setting && JSON.parse(res.data.user_setting);
            const winList = user_setting?.lottery_user_pool_list || [];
            const blackList = user_setting?.lottery_black_list || [];
            this.lotteryWinList =
              (winList.length &&
                winList.map(item => {
                  if (item.type == 2) {
                    return {
                      subject: item.name,
                      key: item.id,
                      num: item.num,
                      type: 'group'
                    };
                  } else {
                    return {
                      subject: item.name,
                      label: item.name,
                      key: item.id,
                      num: 0,
                      type: 'user'
                    };
                  }
                })) ||
              [];
            this.lotteryBlackList =
              (blackList.length &&
                blackList.map(item => {
                  if (item.type == 2) {
                    return {
                      subject: item.name,
                      key: item.id,
                      num: item.num,
                      type: 'group'
                    };
                  } else {
                    return {
                      subject: item.name,
                      label: item.name,
                      key: item.id,
                      num: 0,
                      type: 'user'
                    };
                  }
                })) ||
              [];
            const conditionInfo =
              res.data.lottery_condition && JSON.parse(res.data.lottery_condition);
            // 口令抽奖
            if (res.data.lottery_type == 8) {
              this.conditionForm.lottery_code = conditionInfo.command;
            }
            // 问卷
            if (res.data.lottery_type == 2) {
              this.lottery_question = conditionInfo;
            }
            // 问答
            if (res.data.lottery_type == 21) {
              this.lottery_qa = conditionInfo;
            }
          }
        });
      },
      // 保存条件设置
      sureConditionInfo() {
        let params = {
          webinar_id: this.$route.params.str,
          lottery_id: this.lotteryId,
          lottery_type: this.conditionForm.lottery_type,
          show_discontent_tips: this.conditionForm.lottery_tips,
          can_repeat_lottery: Number(this.conditionForm.lottery_repeat),
          can_remaining_lottery: Number(this.conditionForm.can_remaining_lottery),
          can_look_winner_list: Number(this.conditionForm.lottery_look),
          can_block_overseas: Number(this.conditionForm.can_block_overseas),
          lottery_condition: null
        };
        // 口令
        if (this.conditionForm.lottery_type == 8) {
          if (!this.conditionForm.lottery_code) {
            this.messageInfo(this.$t('lang.k_228088'));
            return;
          }
          let code = {
            command: this.conditionForm.lottery_code
          };
          params.lottery_condition = JSON.stringify(code);
        }
        // 问卷
        if (this.conditionForm.lottery_type == 2) {
          if (this.lottery_question.type == 3 && !this.lottery_question.survey_list.length) {
            this.messageInfo(this.$t('lang.k_228089'));
            return;
          }
          params.lottery_condition = JSON.stringify(this.lottery_question);
        }
        // 问答
        if (this.conditionForm.lottery_type == 21) {
          if (!this.lottery_qa.fqa_list.length) {
            this.messageInfo(this.$t('lang.k_228090'));
            return;
          }
          params.lottery_condition = JSON.stringify(this.lottery_qa);
        }
        const lotteryList = [...this.lotteryWinList, ...this.lotteryBlackList];
        if (lotteryList.length) {
          const groupList_win =
            this.lotteryWinList.filter(e => e.type == 'group').map(item => item.key) || [];
          const groupList_black =
            this.lotteryBlackList.filter(e => e.type == 'group').map(item => item.key) || [];
          const userList_win =
            this.lotteryWinList.filter(e => e.type == 'user').map(item => item.key) || [];
          const userList_black =
            this.lotteryBlackList.filter(e => e.type == 'user').map(item => item.key) || [];
          let lottery_user_pools = [];
          let lottery_black_list = [];
          //type:2-观众组,3在线用户
          groupList_win.map(e => {
            lottery_user_pools.push({
              id: e,
              type: 2
            });
          });
          groupList_black.map(e => {
            lottery_black_list.push({
              id: e,
              type: 2
            });
          });
          userList_win.map(e => {
            lottery_user_pools.push({
              id: e,
              type: 3
            });
          });
          userList_black.map(e => {
            lottery_black_list.push({
              id: e,
              type: 3
            });
          });
          const list = {
            lottery_user_pool_list: lottery_user_pools,
            lottery_black_list: lottery_black_list
          };
          params.user_setting = JSON.stringify(list);
        }
        this.$fetch('saveConditionInfo', params)
          .then(res => {
            if (res.code === 200) {
              this.messageInfo(this.$t('lang.k_228091'), 'success');
              // this.handleChangeTab({ name: 'second' });
            } else {
              this.messageInfo(res.msg);
            }
          })
          .catch(e => {
            this.messageInfo(e.msg);
          });
      },
      // 条件与设置返回上一页
      // 问卷
      selectQuestion(info) {
        this.lottery_question = info;
      },
      messageInfo(text, type = 'error') {
        this.$vhMessage({
          message: text || this.$t('lang.k_228092'),
          showClose: true,
          // duration: 0,
          type: type,
          customClass: 'zdy-info-box'
        });
      },
      // 快问快答
      selectExam(info) {
        this.lottery_qa = info;
        console.log(info);
      },
      // 观众组选择
      selectAudience(winList, list) {
        this.lotteryWinList = winList;
        this.lotteryBlackList = list;
        console.log(this.lotteryWinList, this.lotteryBlackList, '???');
      },
      // 设置观众组
      settingAudience() {
        this.$refs.settingAudience.openSettingAudience(this.lotteryWinList, this.lotteryBlackList);
      },
      // 导入用户
      showImportUser() {
        let white_list = this.configInfo?.white_list;
        if (white_list == 0) return;
        let url = window.location.origin + process.env.VUE_APP_WEB_KEY + '/setting/viewer';
        window.open(url, '_blank');
      },
      // 移除中奖池
      deleteWinList(item) {
        this.lotteryWinList.splice(this.lotteryWinList.indexOf(item), 1);
      },
      // 移除黑名单
      deleteBlackList(item) {
        this.lotteryBlackList.splice(this.lotteryBlackList.indexOf(item), 1);
      },
      // 隐私协议变更
      complianceChange({ privacyHtm }) {
        this.privacyHtm = privacyHtm;
      },
      // 获取隐私协议数据
      async getPrivacyAgreement() {
        if (!this.lotteryId) return;
        const params = {
          webinar_id: this.$route.params.str,
          module: 2, // 所属模块： 1 观看限制 2 抽奖 3 互动有礼
          source_id: this.lotteryId
        };
        const [err, res] = await to(this.$fetch('getPrivacyAgreement', params));
        if (err || !res || res.code != 200) {
          this.$message.error(err.msg || res?.msg || this.$t('lang.k_228093'));
          return false;
        }
        this.privacyStatementData = {
          statement_status: res.data.statement_status,
          statement_content: res.data.statement_content || '',
          statement_info: res.data.statement_info || []
        };
      },
      // 保存隐私协议
      async savePrivacyAgreement() {
        if (this.privacyStatementData.statement_status === 1) {
          // 自定义协议时的校验
          if (
            !this.privacyStatementData.statement_content ||
            !Array.isArray(this.privacyStatementData.statement_info) ||
            this.privacyStatementData.statement_info.length === 0
          ) {
            this.$vhMessage.error(this.$t('lang.k_228094'));
            return;
          }
          const hasEmpty = this.privacyStatementData.statement_info.some(item => {
            return !item.title || !item.link;
          });
          if (hasEmpty) {
            this.$vhMessage.error(this.$t('lang.k_228094'));
            return;
          }
        }
        const params = {
          webinar_id: this.$route.params.str,
          module: 2, // 所属模块： 1 观看限制 2 抽奖 3 互动有礼
          source_id: this.lotteryId,
          ...this.privacyStatementData
        };
        if (Array.isArray(params.statement_info)) {
          // 保存提交的时候用字符串
          params.statement_info = JSON.stringify(params.statement_info);
        }
        const [err, res] = await to(this.$fetch('savePrivacyAgreement', params));
        if (err || !res || res.code != 200) {
          this.$message.error(err.msg || res?.msg || this.$t('lang.k_228093'));
          return false;
        }
        return true;
      },
      // 抽奖页面获取信息
      lotteryGet() {
        if (!this.lotteryId) return;
        let params = {
          webinar_id: this.$route.params.str,
          lottery_id: this.lotteryId
        };
        this.$fetch('getLivePrizeInfo', params)
          .then(res => {
            if (res.code == 200 && res.data) {
              this.formData.description = res.data.description;
              this.formData.title = res.data.title;
              this.formData.reDescription = res.data.description;
              this.formData.reTitle = res.data.title;
              this.formData.lottery_method =
                (res.data.lottery_method && parseInt(res.data.lottery_method + '')) || 0;
              this.formData.lottery_countdown =
                (res.data.lottery_countdown && parseInt(res.data.lottery_countdown + '')) || '';
              this.formData.display_of_results =
                (res.data.display_of_results && parseInt(res.data.display_of_results + '')) || 0;
              this.localLottery = res.data;
              if (parseInt(res.data.img_order) > 0) {
                this.isChecked = parseInt(res.data.img_order);
                // this.backgroundImg = res.data.img_path;
                this.backgroundImg = this.prizeUrl[res.data.img_order - 1] || res.data.img_path;
              } else {
                this.isChecked = 0;
                // this.backgroundImg = res.data.img_path;
                this.backgroundImg = this.prizeUrl[res.data.img_order - 1] || res.data.img_path;
                this.previewSrc = res.data.img_path;
              }
            }
          })
          .catch(err => {
            console.log('🚀 ~ file: prizeSet.vue ~ line 391 ~ this.$fetch ~ err', err);
            this.$vhMessage({
              message: err.msg || this.$t('lang.k_228095'),
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          });
      },
      // 抽奖页保存按钮
      lotterySave() {
        if (this.formData.lottery_method == 1 && !this.formData.lottery_countdown) {
          this.$vhMessage({
            message: this.$t('lang.k_228096'),
            showClose: true,
            // duration: 0,
            type: 'error',
            customClass: 'zdy-info-box'
          });
          return;
        }
        let imgUrl = '';
        let k = 100309;
        let arrImg = [100309, 100310, 100311];
        if (parseInt(this.isChecked) > 0) {
          imgUrl = this.prizeUrl[this.isChecked - 1];
          k = arrImg[this.isChecked - 1];
        } else {
          imgUrl = this.previewSrc;
          k = 100312;
        }
        let params = {
          webinar_id: this.$route.params.str,
          title: this.formData.title,
          img_path: imgUrl,
          img_order: this.isChecked,
          lottery_id: this.lotteryId,
          description: this.formData.description,
          lottery_method: this.formData.lottery_method,
          display_of_results: this.formData.display_of_results
        };
        if (this.formData.lottery_method == 1) {
          params.lottery_countdown = this.formData.lottery_countdown;
        }
        this.$fetch('savePrizeInfo', params)
          .then(res => {
            this.lotteryId = res.data;
            this.$vhall_paas_port({
              k: k,
              data: {
                business_uid: this.userId,
                user_id: '',
                webinar_id: this.$route.params.str,
                refer: '',
                s: '',
                report_extra: {},
                ref_url: '',
                req_url: ''
              }
            });
            if (this.formData.title !== this.formData.reTitle) {
              this.$vhall_paas_port({
                k: 100313,
                data: {
                  business_uid: this.userId,
                  user_id: '',
                  webinar_id: this.$route.params.str,
                  refer: '',
                  s: '',
                  report_extra: {},
                  ref_url: '',
                  req_url: ''
                }
              });
            }
            if (this.formData.description !== this.formData.reDescription) {
              this.$vhall_paas_port({
                k: 100314,
                data: {
                  business_uid: this.userId,
                  user_id: '',
                  webinar_id: this.$route.params.str,
                  refer: '',
                  s: '',
                  report_extra: {},
                  ref_url: '',
                  req_url: ''
                }
              });
            }
            this.$vhMessage({
              message: this.$t('lang.k_228091'),
              showClose: true,
              // duration: 0,
              type: 'success',
              customClass: 'zdy-info-box'
            });
            this.handleChangeTab({ name: 'first' });
          })
          .catch(err => {
            this.$vhMessage({
              message: err.msg || this.$t('lang.k_228097'),
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          });
      },
      setPrizePortData() {
        let prizeArr = ['', 100315, 100316, 100317];
        if (this.givePrizeList.length !== this.lotteryPageMessage.length) {
          let len = this.givePrizeList.length - 3;
          this.$vhall_paas_port({
            k: 100322,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.$route.params.str,
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
          this.$vhall_paas_port({
            k: 100323,
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.$route.params.str,
              refer: '',
              s: '',
              report_extra: { length: len },
              ref_url: '',
              req_url: ''
            }
          });
        }
        this.givePrizeList.forEach((ele, index) => {
          this.$vhall_paas_port({
            k: prizeArr[ele.rank],
            data: {
              business_uid: this.userId,
              user_id: '',
              webinar_id: this.$route.params.str,
              refer: '',
              s: '',
              report_extra: {},
              ref_url: '',
              req_url: ''
            }
          });
          if (ele.field === this.$t('lang.k_228080')) {
            this.$vhall_paas_port({
              k: ele.is_required ? 100318 : 100319,
              data: {
                business_uid: this.userId,
                user_id: '',
                webinar_id: this.$route.params.str,
                refer: '',
                s: '',
                report_extra: {},
                ref_url: '',
                req_url: ''
              }
            });
          }
          if (ele.field === this.$t('lang.k_228098')) {
            this.$vhall_paas_port({
              k: ele.is_required ? 100320 : 100321,
              data: {
                business_uid: this.userId,
                user_id: '',
                webinar_id: this.$route.params.str,
                refer: '',
                s: '',
                report_extra: {},
                ref_url: '',
                req_url: ''
              }
            });
          }
        });
        // if (this.givePrizeForm.this.lotteryPageMessage)
      },
      changeImg() {
        this.$fetch('uploadImage')
          .then(res => {
            this.$vhMessage({
              message: this.$t('lang.k_228091'),
              showClose: true,
              // duration: 0,
              type: 'success',
              customClass: 'zdy-info-box'
            });
          })
          .catch(err => {
            this.$vhMessage({
              message: err.msg || this.$t('lang.k_228097'),
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          });
      },
      addField() {
        if (this.givePrizeList.length == 6) {
          this.$vhMessage({
            message: this.$t('lang.k_228099'),
            showClose: true,
            // duration: 0,
            type: 'error',
            customClass: 'zdy-info-box'
          });
          return false;
        }
        this.index++;
        this.givePrizeList.push({
          is_system: 0,
          field: this.$t('lang.k_228100', [this.index]),
          field_key: 'user_define_' + (this.givePrizeList.length + 97),
          is_required: false,
          placeholder: this.$t('lang.k_228101'),
          rank: this.givePrizeList.length + 97
        });
      },
      deleteGivePrize(index) {
        this.givePrizeList.splice(index, 1);
      },
      // 获取“领奖页设置”信息
      getGivePrize() {
        this.$fetch('getDrawPrizeInfo', {
          webinar_id: this.$route.params.str,
          lottery_id: this.lotteryId
        }).then(res => {
          this.radioType = res.data.receive_award_way + '';
          this.compulsory_award =
            (res.data.compulsory_award && parseInt(res.data.compulsory_award + '')) || 0;
          console.log(res.data, '获取领奖页信息');
          if (this.radioType == 1) {
            this.givePrizeList = JSON.parse(res.data.json_data);
            console.log('givePrizeList:', JSON.stringify(this.givePrizeList));
            // 深拷贝一个对象做对比
            this.lotteryPageMessage = JSON.parse(res.data.json_data);
            this.givePrizeList.forEach(ele => {
              this.givePrizeForm[ele.field_key] = ele.placeholder;
            });
            this.givePrizeList.map(item => {
              item.is_required = Boolean(item.is_required);
              // 补充is_check字段
              this.$set(item, 'is_check', Number(item.is_check));
            });
          } else if (this.radioType == 2) {
            this.privatePrizeList = JSON.parse(res.data.json_data);
            this.privatePrizeList.forEach(ele => {
              this.privatePrizeForm[ele.field_key] = ele.placeholder;
            });
          } else if (this.radioType == 4) {
            this.customPrizeForm = JSON.parse(res.data.json_data)[0];
          }
        });
        // 获取隐私协议数据
        this.getPrivacyAgreement();
      },
      // 保存“领奖页设置”信息
      async sureGivePrize() {
        if (this.radioType == 1) {
          // 保存隐私协议
          const isOk = await this.savePrivacyAgreement();
          if (!isOk) return;
        }

        let result = [];
        if (this.radioType == 1) {
          this.givePrizeList.forEach(ele => {
            // console.warn(this.givePrizeForm[ele.field_key], 789, this.givePrizeForm, ele.field_key);
            ele.placeholder = this.givePrizeForm[ele.field_key];
          });
          result = this.givePrizeList;
        } else if (this.radioType == 2) {
          this.privatePrizeList.forEach(ele => {
            ele.placeholder = this.privatePrizeForm[ele.field_key];
          });
          result = this.privatePrizeList;
        } else if (this.radioType == 4) {
          const isValid = await this.$refs.customPrizeForm.validate();
          if (!isValid) return;
          result = [this.customPrizeForm];
        }

        console.warn(result);
        this.$fetch('saveDrawPrizeInfo', {
          webinar_id: this.$route.params.str,
          lottery_id: this.lotteryId,
          receive_award_way: this.radioType,
          compulsory_award: this.compulsory_award,
          data: JSON.stringify(result)
        })
          .then(res => {
            if (res.code == 200) {
              this.$vhMessage({
                message: this.$t('lang.k_228091'),
                showClose: true,
                // duration: 0,
                type: 'success',
                customClass: 'zdy-info-box'
              });
              // this.handleChangeTab({ name: 'third' });
              this.setPrizePortData();
            }
          })
          .catch(err => {
            this.$vhMessage({
              message: err.msg || this.$t('lang.k_228097'),
              showClose: true,
              // duration: 0,
              type: 'error',
              customClass: 'zdy-info-box'
            });
          });
      },
      handleChangeTab(tab) {
        this.activeName = tab.name;
        const query = {
          ...this.$route.query,
          index: tab.name
        };
        if (this.lotteryId) {
          query.lotteryId = this.lotteryId;
        }
        this.$router.push({
          path: `${isEmbed() ? '/embed' : ''}/live/prizeSet/${this.$route.params.str}`,
          query
        });
        if (tab.name === 'first') {
          this.lotteryGet();
        } else if (tab.name === 'second') {
          this.getGivePrize();
        } else if (tab.name === 'third') {
          this.$refs.prizeTable.getTableList();
        } else if (tab.name === 'four') {
          this.getConditionInfo();
        }
      },
      deleteImg() {
        this.previewSrc = '';
        this.isChecked = 1;
        this.backgroundImg = this.prizeUrl[0];
      },
      changeType(index) {
        this.isChecked = index;
        this.backgroundImg = this.prizeUrl[index - 1];
        if (!index) {
          this.backgroundImg = this.previewSrc;
        }
      },
      prizeLoadSuccess(res, file) {
        console.log('图片上传', res, 'ssssss', file);
        this.previewSrc = res.data.domain_url;
        this.isChecked = 0;
        this.backgroundImg = res.data.domain_url;
      },
      privatePrizeLoadSuccess(res, file) {
        console.log('图片上传', res, 'ssssss', file);
        this.privatePrizeForm.private_qrcode = res.data.domain_url;
      },
      deletePrivateImg() {
        this.privatePrizeForm.private_qrcode = '';
      },
      beforeUploadHandler(file) {
        console.log(file);
        const typeList = ['png', 'jpeg', 'gif', 'bmp'];
        console.log(file.type.toLowerCase());
        let typeArr = file.type.toLowerCase().split('/');
        const isType = typeList.includes(typeArr[typeArr.length - 1]);
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isType) {
          this.$vhMessage({
            message: this.$t('lang.k_228102'),
            showClose: true,
            // duration: 0,
            type: 'error',
            customClass: 'zdy-info-box'
          });
          return false;
        }
        if (!isLt2M) {
          this.$vhMessage({
            message: this.$t('lang.k_228103'),
            showClose: true,
            // duration: 0,
            type: 'error',
            customClass: 'zdy-info-box'
          });
          return false;
        }
        return isType && isLt2M;
      },
      createPrize() {
        this.$refs.createPrize.dialogVisible = true;
      },
      changePrize() {
        this.$refs.createPrize.dialogPrizeVisible = true;
      },
      inputCount(value) {
        this.formData.lottery_countdown = value.replace(/[^\d]+/, '');
      },
      async handlePhoneCheckChange(val) {
        if (!val) {
          const confirm = await this.$vhConfirm(
            this.$t('lang.k_228104'),
            this.$t('lang.k_228069'),

            {
              roundButton: true,
              confirmButtonText: this.$t('lang.k_228105'),
              cancelButtonText: this.$t('lang.k_228106'),
              customClass: 'zdy-message-box',
              lockScroll: false,
              closeOnClickModal: false,
              closeOnPressEscape: false,
              cancelButtonClass: 'zdy-confirm-cancel'
            }
          ).catch(() => false);
          if (!confirm) {
            // 暂不关闭, 把开关状态还原回去
            for (const item of this.givePrizeList) {
              if (item.field_key === 'phone') {
                item.is_check = 1;
                break;
              }
            }
          }
        }
      }
    }
  };
</script>

<style lang="less" scoped>
  .set-btn {
    color: #3562fa;
    position: relative;
    .example-preview {
      visibility: hidden;
      position: absolute;
      right: -155px;
      top: 0;
      width: 151px;
      height: 277px;
      z-index: 2;
      img {
        width: 100%;
        height: 100%;
      }
    }
    &:hover {
      .example-preview {
        visibility: visible;
      }
    }
  }
  .set-code {
    margin-right: 38px;
  }
  .color_red {
    color: #fb3a32;
  }
  .prize-card {
    height: 100%;
    .card__body {
      padding: 0;
      background: #fff;
      // max-width: 1374px;
      margin: auto;
      border-radius: 4px;
      .lottery_method {
        display: flex;
        align-items: center;
        height: 40px;
        .vh-input {
          width: 85px;
          margin: 0 8px;
        }
      }
    }

    /deep/.vh-tabs__content {
      min-height: 700px;
    }
    .prize-info {
      margin: 12px 0;
      // .question-list{
      //   padding: 24px 0;
      // }
    }
    .prize-list {
      padding: 33px 24px;
      .head-operat {
        margin-bottom: 30px;
      }
    }
    .give-item {
      padding: 12px 24px 16px 24px;
      display: flex;
      /deep/.vh-form {
        position: relative;
      }
      .give-prize {
        width: 530px;
        margin-right: 80px;
        // .prize-con{
        //   display: flex;
        // }
        .isDelete {
          height: 20px;
          display: flex;
          justify-content: flex-end;
          i {
            font-size: 16px;
            vertical-align: top;
            line-height: 40px;
            cursor: pointer;
          }
        }
        .switch__box {
          display: inline-block;
          padding-left: 5px;
        }
        /deep/.vh-button {
          margin-top: 16px;
        }
        &-previewImg {
          width: 240px;
          height: 240px;
        }
      }
      .add-prize {
        margin-left: 100px;
        margin-bottom: 10px;
        font-size: 14px;
        color: #3562fa;
        cursor: pointer;
        i {
          color: #3562fa;
          // border: 1px dashed #3562FA;
        }
        .vh-icon-plus:before {
          font-weight: bolder;
        }
      }
      .give-show {
        width: 370px;
        height: 631px;
        background-image: url('../../../common/images/gif/prize.png');
        background-size: cover;
        margin-top: -25px;
        position: absolute;
        left: 600px;
        top: 0;
        .give-people {
          .accept-review.way1 {
            position: absolute;
            margin: auto;
            left: 0;
            right: 0;
            bottom: 0;
            width: 276px;
            height: auto;
            margin-left: 0;
            background-image: url('../../../common/images/gif/accept-review2.png');
            background-size: 100%;
            background-repeat: no-repeat;
            border-radius: 0 0 24px 24px;

            .has-close {
              position: absolute;
              top: 12px;
              right: 14px;
              &:after {
                content: '\00D7';
                font-size: 18px;
                font-weight: normal;
                color: #ffce70;
              }
            }

            .privacy-preview {
              display: block;
              position: relative;
              z-index: 2;
              font-size: 12px;
              padding: 10px 15px;
              line-height: 1.5;
              background: linear-gradient(37.94deg, #fffbe8 3.86%, #fbf0e6 84.36%);
              border-bottom-left-radius: 24px;
              border-bottom-right-radius: 24px;

              /deep/a {
                font-style: normal;
                font-weight: 400;
                font-size: 12px;
                line-height: 1.5;
                word-break: break-word;
                text-decoration: none;
                font-weight: 400;
                color: #3562fa;
                transform: matrix(0.99, 0, -0.14, 1, 0, 0);

                &:hover {
                  color: #3562fa;
                }
              }
            }
          }

          .accept-review.way2 {
            margin: auto;
            margin-top: 227px;
            width: 276px;
            height: 279px;
            margin-left: 0;
            background-image: url('../../../common/images/gif/accept-review.png');
            background-size: 100%;
            background-repeat: no-repeat;
            border-radius: 0 0 24px 24px;
          }

          h3 {
            text-align: center;
            font-size: 14px;
            height: 40px;
            line-height: 40px;
            color: #1a1a1a;
            position: relative;
            i {
              position: absolute;
              top: 12px;
              right: 12px;
              cursor: pointer;
            }
          }
          .sureBtn {
            width: 128px;
            margin: auto;
            text-align: center;
            background: #ffd1c9;
            color: #fff;
            font-size: 14px;
            height: 32px;
            line-height: 32px;
            border-radius: 20px;
          }

          .padding-container {
            padding-top: 45px;
          }
          ::-webkit-scrollbar {
            display: none;
          }
          .give-msg {
            text-align: center;
            margin: 10px auto 16px;
            height: 160px;
            padding: 0 16px;
            overflow-y: auto;

            p {
              margin-top: 24px;
            }
            .red {
              position: absolute;
              left: 0px;
              top: 2px;
              display: inline-block;
              color: #fe6a6a;
              margin-right: 10px;
            }
          }
          .form-item {
            // padding-left: 15px;
            background: #fff;
            border-radius: 4px;
            margin-bottom: 9px;
            /deep/ input {
              border: 0;
              color: #bfbfbf;
            }
          }
        }
        .prize-mask {
          position: absolute;
          top: 85px;
          left: 50px;
          width: 276px;
          height: 505px;
          background: rgba(#000, 0.7);
          border-radius: 0 0 24px 24px;
          &.partScreen {
            bottom: 42px;
            top: auto;
            height: 306px;
            background-size: cover;
            border-radius: 0 0 24px 24px;
            background: url('./images/modal.png') top no-repeat;
            .prize-show {
              margin-top: 0;
            }
          }
          .custom_receive {
            height: 100%;
            border-radius: 0 0 30px 30px;
            overflow: hidden;
            position: relative;
            img {
              width: 100%;
              height: 100%;
            }
            a {
              position: absolute;
              display: block;
              background: #fb2626;
              font-size: 13px;
              min-width: 120px;
              border-radius: 30px;
              padding: 10px 16px;
              color: #fff;
              bottom: 144px;
              left: 50%;
              transform: translateX(-50%);
              text-align: center;
              white-space: nowrap;
            }
          }
        }
        .prize-show {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          margin: 0 auto;
          text-align: center;
          width: 200px;
          height: 230px;
          background-size: 100%;
          background-repeat: no-repeat;
          margin-top: 16px;
          background-position: center;
          .prize-title {
            position: absolute;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            font-size: 12px;
            color: #fff;
            transform-origin: center left;
          }
          .prize-title_00 {
            bottom: -10px;
            left: 30px;
            width: 150px;
          }
          .prize-title_01 {
            bottom: 24px;
            left: 70px;
            width: 90px;
            transform: scale(0.7);
          }
          .prize-title_02 {
            top: 25px;
            left: 55px;
            width: 118px;
            transform: scale(0.8);
          }
          .prize-title_03 {
            bottom: 72px;
            left: 75px;
            width: 75px;
            transform: scale(0.7);
          }
        }
      }
      .prize-type {
        display: flex;
        text-align: center;
        justify-content: space-between;
        .przieImg {
          width: 88px;
          height: 88px;
          border-radius: 4px;
          border: 1px solid #ccc;
          position: relative;
          transition: all 0.15s ease-in;
          &:hover {
            box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.08), 0px 2px 4px 0px rgba(0, 0, 0, 0.02);
          }
          &.active {
            border: 1px solid #fb3a32;
            box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.08), 0px 2px 4px 0px rgba(0, 0, 0, 0.02);
          }
          img {
            width: 100%;
            height: 100%;
          }
          .img-tangle {
            position: absolute;
            right: 0;
            top: 0;
            width: 20px;
            height: 20px;
            font-size: 0;
            img {
              width: 100%;
              height: 100%;
            }
          }
        }
        .prizeNoBorder {
          border: 0;
          /deep/.vh-upload--picture-card {
            height: 88px;
          }
          /deep/.vh-upload--picture-card .box > div {
            height: 88px;
          }
        }
        .checkedBorder {
          border: 1px solid #fb3a32 !important;
          /deep/.vh-upload--picture-card {
            border: 0;
            height: 86px;
          }
        }
      }
      .award-save {
        margin-left: 100px;
        /deep/.vh-button {
          margin-top: 28px;
        }
      }
    }
    .prize-no {
      height: calc(100vh - 260px);
      text-align: center;
      margin-top: 268px;
    }
  }
  .set_audience {
    color: #3562fa;
    cursor: pointer;
    &.set_left {
      margin-left: 12px;
    }
  }
  .set_user {
    color: rgba(0, 0, 0, 0.85);
    line-height: 36px;
  }
  .set_list {
    max-height: 160px;
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    &_item {
      background: #f0f0f0;
      border-radius: 4px;
      padding: 0 12px;
      height: 30px;
      line-height: 30px;
      display: flex;
      font-size: 14px;
      justify-content: space-between;
      &:hover {
        p {
          color: #fb3a32;
        }
        span {
          color: #fb3a32;
        }
      }
      p {
        max-width: 180px;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: #595959;
        padding-right: 5px;
      }
      span {
        color: #595959;
        i {
          padding-left: 5px;
          font-size: 12px;
          cursor: pointer;
        }
      }
    }
  }
  .condition_btn {
    margin-left: 150px;
    // margin-top: 30px;
  }
  .award-no {
    width: 380px;
    height: 320px;
    background: rgba(0, 0, 0, 0.02);
    border-radius: 8px;
    margin-left: 100px;
    &-wrapper {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
    }
    span {
      width: 120px;
      height: 130px;
      display: inline-block;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    p {
      line-height: 20px;
      margin-top: 12px;
      font-size: 14px;
      text-align: center;
      color: rgba(0, 0, 0, 0.65);
    }
  }
  .reward-container_service {
    text-align: center;
    width: 248px;
    height: 212px;
    background: #fff;
    border-radius: 4px;
    margin: 10px auto;
    padding: 0 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    .reward-service {
      width: 120px;
      height: 120px;
      margin: 0 auto;
      margin-bottom: 5px;
      img {
        width: 100%;
        height: 100%;
        object-fit: scale-down;
      }
    }
    .service-title {
      width: 218px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      font-size: 14px;
      line-height: 32px;
      height: 32px;
      text-align: center;
      color: rgba(0, 0, 0, 0.85);
    }
  }
  .give-show_no {
    width: 267px;
    height: 257px;
    margin: 0 auto;
    margin-top: 98px;
    img {
      width: 100%;
      height: 100%;
      object-fit: scale-down;
    }
  }
  /deep/.saasicon_help_m {
    color: #999999;
  }
  .give-condition {
    /deep/.vh-radio {
      height: 40px;
    }
    &_option {
      /deep/.vh-form-item__label {
        line-height: 18px;
      }
    }
    &_user {
      /deep/.vh-form-item__label {
        line-height: 36px;
      }
    }
  }
  .notice_txt {
    display: block;
    font-size: 12px;
    line-height: 22px;
    // margin-top: 6px;
    color: #666;
    text-align: left;
  }
</style>
<style lang="less">
  .prize-card {
    .card__body .give-prize {
      .vh-form-item__content {
        // display: flex;
        // align-items: center;
      }
      .lottery_method {
        display: flex;
        align-items: center;
        height: 40px;
        .vh-cascader-node > .vh-radio,
        .vh-radio:last-child {
          display: flex;
          align-items: center;
          .vh-radio__label {
            display: flex;
            align-items: center;
          }
          .vh-input-group__append {
            padding: 0 8px;
          }
        }
        .vh-input {
          width: 114px;
          margin: 0 8px;
        }
      }
      .prize-con {
        .vh-switch__label > span {
          line-height: 1.4;
          // color: #262626;
        }
      }
      .vh-switch__label.is-active {
        color: #8c8c8c;
      }
    }
  }
</style>
